export default "__VITE_ASSET__BZR_ewEr__"